<!-- <div class="suggestion-container p-8 pb-6 radius-m white-bg dropdown-shadow hide">
    <div class="header-wrapper">
        <div class="relative-time-part">
            <ng-container *ngFor="let relative_obj of show_relative_times">
                <p class="px-2 content-m enable-action" [tooltip]="relative_obj.disp" [ngClass]="relative_obj.disp == selectedTimeRange?'selected-time chips-active':'chips-default'" (click)="toggleselectRelativeTime(relative_obj)">{{relative_obj.disp}}</p>

            </ng-container>

        </div>
        <div class="relative-time" >
            <p class=" pl-2 content-m selectable-text enable-action"  #time (click)="openRealtiveTimePanelClick(time)">Relative Time</p> -->
            <!-- <div class="relative-time-col-1" #timeRangeOrigin>
                <app-overlay-select [data]="relative_time_options" [origin]="timeRangeOrigin"
                    [style]="{'font-size':'9px'}" [label]="'Relative Time'">
                </app-overlay-select>
            </div> -->
        <!-- </div>
        <div class="custom-time">
            <p class="content-m selectable-text enable-action" #CustomTime (click)="openCustomTimePanelClick(CustomTime)">Custom Time Range</p> -->
            <!-- <div class="custome-time" #customRangeOrigin>
                <app-overlay-select [data]="relative_time_options" [origin]="customRangeOrigin"
                    [style]="{'font-size':'9px'}" [label]="'Custome Time'">
                </app-overlay-select>
            </div> -->
        <!-- </div>
        <div class="fields-suggestion">
            <ng-container *ngFor="let chip of suggestion_chips">
                <span class="chip-wrapper">
                    <span class="chip-key" [tooltip]="selectedfield">{{selectedfield}}</span>
                    <span class="chip-opertor"> =</span>"
                    <span class="chip-value" [tooltip]="chip">{{chip}}</span>"
                </span>
            </ng-container>
        </div>
        <div class="show-events">
            <p class="content-m selectable-text enable-action">Show 100 Events</p>
        </div>
    </div>
    <div class="body-wrapper">
        <div class="platform-wrapper ">

            <div class="header">
                <p class="content-l bold-text primary-text">Platforms</p>

            </div>
            <div class="action-wrapper"> -->
                <!-- <div class="search-container">
                    <form action="/search" method="get">
                      <input class="search" id="searchleft" type="search" name="q" placeholder="Search">
                      <label class="button searchbutton" for="searchleft"><span class="mglass">&#9906;</span></label>
                    </form>
                </div> -->
                <!-- <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="platformSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div></div>
            </div>
            <ng-container *ngIf="!suggestionplatformSpinnerState">
                <div class="content">
                    <ng-container *ngIf="platformList.length>0">
                        <ng-container *ngFor="let platforms of platformList">
                            <div class="display-text border-light-bottom pl-0 p-3">
                                
                                    <img class="icon-s" src="../../../assets/rule/greenTick.svg" [ngClass]="platforms.selected ?'':'default-icon'">

                                    <span [id]="platforms.value" class="content-m" [tooltip]="platforms.disp"
                                    [ngClass]="platforms.disp == selectedPlatform?'enable':'disable'"
                                    (click)="ClickedPlatform(platforms)">{{platforms.disp}}</span> -->

                                <!-- <span [id]="platforms.value" class="content-m" [tooltip]="platforms.disp"
                                    [ngClass]="platforms.disp == selectedPlatform?'enable':'disable'"
                                    (click)="ClickedPlatform(platforms)">{{platforms.disp}}</span> -->
                            <!-- </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="platformList.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionplatformSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>

        </div>
        <div class="source-wrapper pl-5 border-light-left">

            <div class="header">
                <p class="content-l bold-text primary-text">Partitions</p>
            </div>
            <div class="action-wrapper pl-3">
                
                    <label class="checkbox-container content-m primary-text"> -->
                        <!-- <span class="dot"></span>
                        <input type="checkbox" class="shadow-none enable-action tooltip-enable" tooltip="Select all" (click)="$event.stopPropagation()" [formControl]="sourceSelectAll"> --> 
                        <!-- <span class="checkmark"></span> -->
                     <!-- </label>
                
                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="sourceSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div>

                </div>

            </div>
            <ng-container *ngIf="!suggestionsourceSpinnerState">
                <div class="content">
                    <ng-container *ngIf="selectedHost.length>0">
                        <ng-container *ngFor="let host of selectedHost;let i =index;">
                            <div class="display-text border-light-bottom pl-0 p-3" [ngClass]="partitionLimitReached && !host.isSelected ? 'tooltip-enable':''" tooltip="Limit reached">
                                <label class="checkbox-container content-l primary-text" [tooltip]="host.disp" [ngClass]="partitionLimitReached && !host.isSelected ? ' non-clickable permission-denied ':''" >{{host.disp}}
                                    <span class="dot content-m"></span>
                                    <input class="enable-action shadow-none" type="checkbox" [checked]="host.isSelected" (click)="selectedSource(i,host,$event)"> -->
                                    <!-- <span class="checkmark"></span> -->
                                <!-- </label>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="selectedHost.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="suggestionsourceSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        <div class="fields-wrapper pl-5 border-light-left">

            <div class="header">
                <p class="content-l bold-text primary-text">Fields</p>
            </div>
            <div class="action-wrapper">
                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="fieldsSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div>

                </div>
            </div>
            <ng-container *ngIf="!suggestionfieldSpinnerState">
                <div class="content">
                    <ng-container *ngIf="fieldsList.length>0">
                        <ng-container *ngFor="let fields of fieldsList">
                            <div class="display-text border-light-bottom pl-0 p-3" *ngIf="fields.is_view">
                                <img class="icon-xs" [src]="fields.display_type=='Text'?'assets/text-field.svg':'assets/fields.svg'"
                                    alt="">
                                <span class="content-m" [tooltip]="fields.disp"
                                    [ngClass]="fields.disp == selectedfield?'enable':'disable'"
                                    (click)="SelectedFields(fields,$event)">{{fields.disp}}</span>
                                <div class="display-count"> -->
                                    <!-- <p class="display-key">Unique</p> -->
                                    <!-- <p class="value primary-text bold-text m-0 content-m">{{fields.count}}</p>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldsList.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionfieldSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        <div class="value-wrapper border-light-left pl-5">

            <div class="header">
                <p class="content-l bold-text primary-text">Values</p>
            </div>
            <div class="action-wrapper">

                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="valueSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div></div>
            </div>
            <ng-container *ngIf="!suggestionvalueSpinnerState">
                <div class="content">
                    <ng-container *ngIf="fieldsValue.length>0">
                        <ng-container *ngFor="let lexicon of fieldsValue">
                            <ng-container *ngIf="lexicon!='--NA--'">
                                <div class="display-text  border-light-bottom pl-0 p-3">
                                    <span class="content-m" [tooltip]="lexicon"
                                        [ngClass]="lexicon == selectedPlatform?'enable':'disable'">{{lexicon}}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldsValue.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionvalueSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        
    </div>
    <div class="alert-danger content-s alert-text ">
        <div *ngIf="sourceErrorState"> -->
            <!-- Fullname is required -->
            <!-- {{sourceErrorMsg}}
        </div>
    </div>
    <div class="footer-wrapper">
        <button mat-button class="cancel"
            [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formCancel()"
            tabindex="0">{{assetsService.lables.cancel}}</button> -->
        <!-- to apply the selected hosts for search -->
        <!-- <button mat-button class="submit"
            [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formSubmit()"
            tabindex="1">{{assetsService.lables.apply}}</button>
    </div>
</div> -->




<div class=" assets dropdown-shadow p-4 radius-m" [formGroup]="form" [ngStyle]="{background:'white'}">
    <div class=" primary-bg radius-m column border-light" [ngStyle]="{display:'flex'}">
        <div class="p-4  header-options ">
            <div class="custom-search" [ngStyle]="{height:'3vh',width:'12vw'}" >
                <img src="assets/settings/search-small.svg">
                <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="assetSearch"
                    (click)="$event.stopPropagation()">
            </div>
            <div class="selection">
                <div class="clear-chips" [ngClass]="selected.length ? 'enable-action' : 'permission-denied'" (click)="resetChips()">
                    <img class="icon-s" src="../../../assets/alerts/clear_all_selection.svg">
                <p  class="content-m selectable-text" >Clear selection</p>
                </div>
                <!-- <p class="content-m primary-text">{{selected.length}} of {{chipsLimit}} Selected</p> -->
            </div>
        </div>
        <div class=" wrap radius-m p-4 pt-0" *ngIf="selectedAlias.length" formArrayName="selectedAlias" [ngStyle]="{display:'flex'}">
           
                <ng-container *ngFor="let chip of selectedAlias.controls; index as i">
                        <div class="chips-active px-2 chips" [formGroupName]="i"  [ngStyle]="{display:'flex',gap:'1vw',width:'fit-content'}">
                            <div class="px-2 chips enable-action" [ngStyle]="{display:'flex',gap:'1vw',width:'fit-content'}" *ngFor="let controlName of getControlNames(chip)" (click)="removeChip(controlName,i)">
                                <p class="content-m noWrap primary-text">{{controlName}}</p>
                                <p class="content-m bold-text hide">AS</p>
                                <input [ngStyle]="{height:'2vh'}" class="input-border hide" [formControlName]="controlName"    type="text">
                                <img class="icon-s enable-action hide" src="../../../assets/rule/close-dialog.svg" (click)="removeChip(controlName,i)">
                                <p class="alert-text content-s"> {{chipsErrors |
                                    oneError : chip.controls[controlName]?.errors}} </p>
                                   
                            </div>

                        </div>

                </ng-container>
        </div>
    </div>

    <!-- <div class="body-wrapper">
        <div class="options"> 
            <div class="clear pr-2 pb-2" (click)="resetSelection()" [ngClass]="selectedNode.length ? 'enable-action': 'permission-denied'">
                <img class="icon-s" src="../../../assets/rule/refresh.svg">
                 <p class="content-m selectable-text">Reset</p>
            </div>
        </div>

        <div class="list-body primary-bg p-3 radius-m border-light" [ngStyle]="{display:'flex'}">
            <ng-container *ngFor="let list of structure | keyvalue:originalOrder ; index as i">
                <div class="list-container">
                    <p class="content-l bold-text list-header ">{{list.key}}</p>
                    <div class="list-wrapper pt-3">
                        <ng-container *ngFor="let val of list.value">
                            <div [id]="val+'_'+sampleData.nodes[val].level" class="list-content p-3" (mouseover)="rootHover(val,sampleData.nodes[val].level)" (click)="rootClick(val,'root')">
                                <p class="content-m enable-action" [ngClass]="[selectedNode === val ? 'selectable-text bolder-text':'primary-text',checkHover(val) ? 'selectable-text bolder-text':'']" >{{getLabel(val)}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="seperator" [ngClass]="i === objectSize(structure)-1 ? 'border-none':'border-light-right'"></div>
            </ng-container>
        </div>
    </div> -->

    <!-- <div class="body-wrapper">
        <div class="options"> 
            <div class="add pr-2 pb-2" (click)="addClick()"  [ngClass]="readyToAdd? 'enable-action': 'permission-denied'"> -->
                <!-- <img class="icon-s" src="../../../assets/rule/plus.svg"> -->
                 <!-- <p class="content-m selectable-text">Add</p>
            </div>
            <div class="clear pr-2 pb-2" (click)="resetSelection()" [ngClass]="selectedNode.length ? 'enable-action': 'permission-denied'">
                <img class="icon-s" src="../../../assets/rule/refresh.svg">
                 <p class="content-m selectable-text">Reset</p>
            </div>
        </div>

        <div class="list-body primary-bg p-3 radius-m border-light" [ngStyle]="{display:'flex'}">
            <ng-container *ngFor="let list of newStructure | keyvalue:originalOrder ; index as i">
                <div class="list-container">
                    <p class="content-l bold-text list-header ">{{list.key}}</p>
                    <div class="list-wrapper pt-3">
                        <ng-container *ngFor="let val of list.value">
                            <div [id]="val+'_'+newSample.nodes[val].level" class="list-content p-3"  (click)="newRootClick(val,'root')">
                                <p class="content-m enable-action" [ngClass]="[selectedPath[newSample?.nodes[val]?.level] === val ? 'selectable-text bolder-text':'primary-text',checkHover(val) ? 'selectable-text bolder-text':'']" >{{getNewLabel(val)}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="seperator" [ngClass]="i === objectSize(structure)-1 ? 'border-none':'border-light-right'"></div>
            </ng-container> -->
        <!-- </div>
    </div> -->
    <div class="body-wrapper">
        <div class="options"> 
            <div class="add pr-2 pb-2" (click)="addChipClick()"  [ngClass]="clickedNode.length === 1? 'enable-action': 'permission-denied'">
                <!-- <img class="icon-s" src="../../../assets/rule/plus.svg"> -->
                 <p class="content-m selectable-text">Add</p>
            </div>
            <div class="clear pr-2 pb-2" (click)="resetEverything()" [ngClass]="objectSize(keepTrackJr) ? 'enable-action': 'permission-denied'">
                <img class="icon-s" src="../../../assets/rule/refresh.svg">
                 <p class="content-m selectable-text">Reset</p>
            </div>
        </div>

        <div class="list-body primary-bg p-3 radius-m border-light" [ngStyle]="{display:'flex'}">
            <ng-container *ngFor="let head of headerObj; index as i ">
                <div class="list-container">
                    <p class="content-l bold-text list-header ">{{head.disp}}</p>
                    <div class="list-wrapper pt-3">
                        <ng-container *ngFor="let val of getcolumn(head.value)">
                            <div class="list-content p-3" *ngIf="val"  (click)="newRootClick(head.value,val,'root')">
                                <p class="content-m enable-action" [ngClass]="checkSelected(val)?'selectable-text' : 'primary-text'">{{val}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="seperator" [ngClass]="i === headerObj.length-1 ? 'border-none':'border-light-right'"></div>
            </ng-container>
            <!-- <ng-container *ngFor="let list of newStructure | keyvalue:originalOrder ; index as i">
                <div class="list-container">
                    <p class="content-l bold-text list-header ">{{list.key}}</p>
                    <div class="list-wrapper pt-3">
                        <ng-container *ngFor="let val of list.value">
                            <div [id]="val+'_'+newSample.nodes[val].level" class="list-content p-3"  (click)="newRootClick(val,'root')">
                                <p class="content-m enable-action" [ngClass]="[selectedPath[newSample?.nodes[val]?.level] === val ? 'selectable-text bolder-text':'primary-text',checkHover(val) ? 'selectable-text bolder-text':'']" >{{getNewLabel(val)}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="seperator" [ngClass]="i === objectSize(structure)-1 ? 'border-none':'border-light-right'"></div>
            </ng-container> -->
        </div>
    </div>
    <div class="footer">
        <p *ngIf="!selectedAlias.value.length || !selectedAlias.valid " class="alert-text content-s">*At least one source must be selected.</p>
        <button class="submit" (click)="submitClick()">Submit</button>
        <button class="cancel" (click)="formCancel()">Cancel</button>
    </div>


</div>